module.exports = __webpack_public_path__ + "static/media/snowflake-color.01138a3c.svg";